export default {
      id: "common__support-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__support",
      toString: function () {
        return this.url;
      }
    }